import React, { Component } from 'react';

class ProgressRing extends Component {
  constructor(props) {
    super(props);

    const { radius, stroke } = this.props;

    this.normalizedRadius = radius - stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
  }

  render() {
    const { radius, stroke, progress, color } = this.props;

    const strokeDashoffset =
      this.circumference - (progress / 100) * this.circumference;
    const strokeDashoffsetcomplete =
      this.circumference - (100 / 100) * this.circumference;

    return (
      <svg height={radius * 2} width={radius * 2} className="svg-graph">
        <circle
          stroke="#D3E0E7"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={this.circumference + ' ' + this.circumference}
          style={{ strokeDashoffsetcomplete }}
          r={this.normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke={color}
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={this.circumference + ' ' + this.circumference}
          style={{ strokeDashoffset }}
          r={this.normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
    );
  }
}

export default ProgressRing;
